export const prefix = "mad";
export const buttonClass = `${prefix}-button`;
export const appbarClass = `${prefix}-appbar`;
export const appbarTitleClass = `${prefix}-appbar-title`;
export const iconButtonClass = `${prefix}-icon-button`;
export const iconClass = `${prefix}-icon`;
export const navigationClass = `${prefix}-navigation`;
export const listClass = `${prefix}-list`;
export const listItemClass = `${prefix}-list-item`;
export const overlayClass = `${prefix}-overlay`;
export const textfieldClass = `${prefix}-textfield`;
export const dropdownFieldClass = `${prefix}-dropdown-field`;
export const checkboxClass = `${prefix}-checkbox`;
export const radioClass = `${prefix}-radio`;
export const treeClass = `${prefix}-tree`;
export const multifieldClass = `${prefix}-multifield`;
export const cardClass = `${prefix}-card`;
export const dataTableClass = `${prefix}-datatable`;
export const tabBarClass = `${prefix}-tab-bar`;
export const tabBarItemClass = `${prefix}-tab-bar-item`;
export const datePickerClass = `${prefix}-datepicker`;
export const avatarClass = `${prefix}-avatar`;
export const menuClass = `${prefix}-menu`;
